import React, { useEffect, useReducer, useState} from 'react';
import {Container, Row,Button, Nav, Accordion} from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import "../stylesheets/style.css"
import "../js/main.js"
import Testimonials from './Testimonials';
import Faq from './Faq';
import Contact from './Contact'
import Subscribe from './Subscribe';

const HomePage = () => {
    useEffect(() =>{
        document.title = "Home | Earth VIII"
    },[])

    const [RotateDown, setRotateDown] = useState()     
    const [RotateDg, setRotateDg] = useState()  

    const rotateDownCSS = {
        transform: "rotate(90deg)",
        transition: "transform 0.9s ease 0s"
      }

      const removerotateDownCSS = {
        transform: "rotate(0deg)",
        transition: "transform 0.9s ease 0s"
      }

      const rotateDgCSS = {
        transform: "rotate(-25deg)",
        transition: "transform 0.2s ease 0s"
      }

      const removerotateDgCSS = {
        transform: "rotate(0deg)",
        transition: "transform 0.2s ease 0s"
      }

    const rotatedown = () =>{
        setRotateDown(rotateDownCSS) 
    }
    const stoprotatedown = () =>{
        setRotateDown(removerotateDownCSS) 
    }

    const rotatedg = () =>{
        setRotateDg(rotateDgCSS) 
    }
    const stoprotatedg = () =>{
        setRotateDg(removerotateDgCSS) 
    }

    return (
      
      <div>
<div className="homepageslider" id="homepageslider">
<Header/>


<div class="col-md-12 hmfirstbox">
    <h1 className="hmherotitle">Building  <span className="makeyellow"> smart.</span> <br/>
        Creating <span className="makeyellow">  memories</span>
    </h1>

    <Row>
        <div class="col-md-3">
            </div>

            <div class="col-md-6">
            <p className="hmherosubtitle fordesktoponly">
            We pay attention - Delivering smart homes & apartments that command high<br/> market value, provide comfort and inspire you to live your best life.
     </p>

     <p className="hmherosubtitle formobileonly">
     We pay attention - Delivering smart homes & apartments that command high market value, provide comfort and inspire you to live your best life.
     </p>

     <p style={{textAlign:"center"}}>
<Nav.Link className="hmheroctabutton " as={Link} eventKey="2"  to="/about"><button className="hmfirstboxbutton3">Learn more</button></Nav.Link>
        <a style={{textDecoration:"none"}} className="hmheroctabutton  hmctabutton2 hmanim1" onMouseEnter={rotatedown} onMouseLeave={stoprotatedown}  href="#contact">
            <p>Talk to us <img style={RotateDown}  src="images/rightarrow.png"/> </p>
            </a>
</p>
    
            </div>

            <div class="col-md-3">
            </div>
        </Row>




</div>

    <div className='hmsecondbox'>
    <div className='container'>
       <div class="row">
           <div class="col-md-5">
               <div class="row mobilerow">
                   <div class="col-md-1 col-2">
                       {/* <h2  className="line hmsecondboxtitle"></h2> */}
                       <img style={{paddingTop:"30px" }} className="" src="images/line.png"/>
                       </div>
                       <div class="col-md-11 col-10" style={{paddingLeft:"25px" }} >
                       <h2 className="hmsecondboxtitle fordesktoponly">  Let us tell you a bit<br/> about us</h2>
                       <h2 className="hmsecondboxtitle formobileonly">  Let us tell you a bit <br/> about us</h2>

                       </div>
                   

               </div>
               <img className="img-fluid hmsecondbox2 formobileonly" src="images/aboutus.png"/>

            <p className="hmseconddescription">Earth VII is a full-service real estate company located in Abuja, Nigeria dedicated
                 to delivering happiness and great designs in our real estate properties. 
                The Earth VII brand represents Quality, Excellence, Luxury and Happy Moments which we communicate 
                in every one of our projects and emphasize in our service delivery.</p>
<p className="hmseconddescription2">Our team consists of a reputable group of experts who work hard to make our vision a reality and offer our clients only the best experiences. We aspire to lead design conscious real estate ventures and promise to build homes to foster happiness and deliver quality.</p>
        
<a className="linkdecoration" target="_blank" href="/about" >   <p onMouseEnter={rotatedg} onMouseLeave={stoprotatedg}  className="learnmorecta">Learn more about us <img className="icorotatediagonal" style={RotateDg}  src="images/rightarrow.png"/></p></a>
       
           </div>

           <div class="col-md-1"></div>

           <div class="col-md-6">
           <img className="img-fluid fordesktoponly" src="images/aboutus.png"/>
           </div>
           
       </div>
        </div>
    </div>

    <div className='hmthirdbox'>
    <div className='container'>
       <div class="row mobilerow">
           <div class="col-md-6">
           <img className="img-fluid" src="images/memories.png"/>


           </div>

          

           <div class="col-md-5">
           <div style={{paddingTop:"50px"}}  class="row letusmobile">
                   <div class="col-md-1 col-2 ">
                       {/* <h2  className="line hmsecondboxtitle"></h2> */}
                       <img style={{paddingTop:"30px" }} className="" src="images/line.png"/>
                       </div>
                       <div class="col-md-11 col-10" style={{paddingLeft:"25px" }}>
                       <h2 className=" hmsecondboxtitlewhite fordesktoponly">  We have been creating <br/><span className="makeyellow">memories</span>, why dont we<br/>create yours.</h2>
                       <h2 className=" hmsecondboxtitlewhite formobileonly">  We have been creating memories, why dont we create yours</h2>

                       </div>
                   

               </div>

            <p className="hmseconddescriptionwhite">
            Inspired by the vision of a happy home, we build luxurious smart homes, finished with exquisite designs that will make your home feel like paradise, while remaining very practical and simple. Our properties are Innovative to blend into the future of real estate, smart to accommodate practical automations and expertly finished with exotic designs that will make your home, your absolute favorite place to be.
                </p>
                <a className="linkdecoration"  target="_blank" href="/homes">   <p onMouseEnter={rotatedown} onMouseLeave={stoprotatedown}  className="learnmorectawhite">See our projects <img className=""   style={RotateDown}   src="images/rightarrow.png"/></p></a>

       
           </div>
       </div>
        </div>
    </div>

    <div className='hmfourthbox'>
    <div className='container'>
        <h1 style={{textAlign:"center"}} className='hmherotitle2 fordesktoponly'> See what we have been <br/>working on lately.</h1>
        <h1 style={{textAlign:"center"}} className='hmherotitle2 formobileonly'> See what we have been working on lately.</h1>

       <div class="row">
           <div class="col-md-5">
               <div class="row mobilerow">
                   <div class="col-md-1 col-2">
                       {/* <h2  className="line hmsecondboxtitle"></h2> */}
                       <img style={{paddingTop:"34px" }} className="" src="images/line.png"/>

                       </div>
                       <div class="col-md-10 col-10" style={{paddingLeft:"25px" }}>
                       <h2 className="stepdown hmsecondboxtitle">  Earth VII Homes</h2>
                       {/* <h2 className=" hmsecondboxtitle formobileonly">  Let us tell you a bit about us</h2> */}

                       </div>
                   

               </div>
               <img className="img-fluid hmsecondbox2 formobileonly" style={{borderRadius:"16px"}} src="images/OAK Grandeur II.jpg"/>

            <p className="hmseconddescription">
            We believe that excellent finishing, smart features, strong architecture and access to amenities like: schools, worship centers, markets, etc… are not extras but are very important in delivering an ultimately beautiful home to you. We are committed to building homes that you'll be proud of; that includes all those little extras to make luxury living about your ultimate comfort.                
                </p>
        
                <a className="linkdecoration" target="_blank" href="/homes" >  <p onMouseEnter={rotatedg} onMouseLeave={stoprotatedg}  className="learnmorecta vohlm">View our homes <img className="" style={RotateDg}   src="images/rightarrow.png"/></p></a>
       <hr className='vohlm'/>
           </div>
           <div class="col-md-1"></div>
           <div class="col-md-6">
           <img className="img-fluid fordesktoponly" style={{borderRadius:"16px"}} src="images/OAK Grandeur II.jpg"/>
           </div>
       </div>
        </div>
    </div>


    <div className='hmfifthbox'>
    <div className='container'>
       <div class="row">

       {/* <div class="col-md-1"></div> */}
           <div class="col-md-6">
           <img className="img-fluid" src="images/EarthVii apartments2 interior.png"/>

           </div>
        
           <div class="col-md-5">

           <div class="row mobilerow">
                   <div class="col-md-1 col-2">
                       {/* <h2  className="line hmsecondboxtitle"></h2> */}
                       <img style={{paddingTop:"34px" }} className="" src="images/line.png"/>

                       </div>
                       <div class="col-md-11 col-10" style={{paddingLeft:"25px" }}>
                       <h2 className="stepdown hmsecondboxtitle ">  Earth VII Apartments</h2>
                       {/* <h2 className=" hmsecondboxtitle formobileonly">  Let us tell you a bit about us</h2> */}

                       </div>
                   

               </div>
               {/* <img className="img-fluid hmsecondbox2 formobileonly" src="images/apartments.png"/> */}

            <p className="hmseconddescription">
            Earth VII Apartments is unique for its intentional interior designs which we modelled after beautiful cities in the world - infusing both the design aesthetics and cultural feeling                
                </p>
        <br/>
                <a   className="linkdecoration" target="_blank" href="/apartments" ><p onMouseEnter={rotatedg} onMouseLeave={stoprotatedg}  style={{cursor:"pointer"}} className="learnmorecta vohlm2">View our apartments <img className="" style={RotateDg}   src="images/rightarrow.png"/></p></a>
       <hr className='vohlm2hr'/>

           </div>
       </div>
        </div>
    </div>

<div className="container">
    {/* <hr/> */}
    {/* <br/> */}
</div>



<Testimonials/>
{/* <Faq/> */}

<div id="contact">
<Contact/>
</div>

<div class="container">
<div class="row hpblogbox">

  
    <div class="row mobilerow">
                   <div class="col-md-1 col-2">
                       {/* <h2  className="line hmsecondboxtitle"></h2> */}
                       <img style={{paddingTop:"34px" }} className="" src="images/line.png"/>

                       </div>
                       <div class="col-md-11 col-10" >
                       <h2 className="stepdown hmsecondboxtitle"> <span> Our latest articles here </span> <span style={{float:"right",fontSize:"12px"}}>                <a   className="linkdecoration fordesktoponly" target="_blank" href="/blog"><p onMouseEnter={rotatedg} onMouseLeave={stoprotatedg}  style={{cursor:"pointer"}} className="learnmorecta vohlm2">View more articles <img className="" style={RotateDg}   src="images/rightarrow.png"/></p></a>
</span></h2>
                    
                       {/* <h2 className=" hmsecondboxtitle formobileonly">  Let us tell you a bit about us</h2> */}

                       </div>
                   

               </div>
   
<div class="col-md-6">
    <div class="row">
        <div class="col-md-4 col-4">
        <img className="img-fluid" src="images/blog/blogthumbnail1.png"/>

        </div>
        <div class="col-md-8 col-8">
        <p className="hpblogtitle">Why and When You Should Invest in <br/>Real Estate in Nigeria</p>
    <p className="hpblogbody fordesktoponly">
    If you are looking for a safe investment option, then real estate should be top on your search list. 


         </p>
         <p className="hpblogbodymobile formobileonly">

         If you are looking for a safe investment option, then real estate should be top on your search list. 
         Real Estate
     </p>

<a   className="linkdecoration hpblogreadmore fordesktoponly" target="_blank" href="/whyandwhenyoushouldinvestinrealestateinnigeria"><p onMouseEnter={rotatedg} onMouseLeave={stoprotatedg}  style={{cursor:"pointer"}} className="learnmorecta vohlm2 hpblogreadmore">Continue reading article <img className="" style={RotateDg}   src="images/rightarrow.png"/></p></a>
    
<a   className="linkdecoration hpblogreadmore " target="_blank" href="/whyandwhenyoushouldinvestinrealestateinnigeria"><p onMouseEnter={rotatedg} onMouseLeave={stoprotatedg}  style={{cursor:"pointer"}} className="learnmorecta vohlm2 hpblogreadmore formobileonly">Continue reading article </p></a>

        </div>
    </div>

</div>
{/* style={{height:"200px", width:"300px",borderRadius:"16px"}}  */}
   
<div class="col-md-6">
    <div class="row">
        <div class="col-md-4 col-4">
        <img className="img-fluid" src="images/blog/blogthumbnail1.png"/>

        </div>
        <div class="col-md-8 col-8">
        <p className="hpblogtitle">An Early Christmas Gift For You</p>
    <p className="hpblogbody fordesktoponly">
    The house you looked at today and wanted to think about until tomorrow may be the same house someone looked at yesterday and will buy today.”


         </p>
         <p className="hpblogbodymobile formobileonly">

         If you are looking for a safe investment option, then real estate should be top on your search list. 
              </p>

<a   className="linkdecoration hpblogreadmore fordesktoponly" target="_blank" href="/anearlychristmasgiftforyou"><p onMouseEnter={rotatedg} onMouseLeave={stoprotatedg}  style={{cursor:"pointer"}} className="learnmorecta vohlm2 hpblogreadmore">Continue reading article <img className="" style={RotateDg}   src="images/rightarrow.png"/></p></a>
    
<a   className="linkdecoration hpblogreadmore" target="_blank" href="/anearlychristmasgiftforyou"><p onMouseEnter={rotatedg} onMouseLeave={stoprotatedg}  style={{cursor:"pointer"}} className="learnmorecta vohlm2 hpblogreadmore formobileonly">Continue reading article </p></a>

        </div>
    </div>

</div>
</div>

<a  style={{textAlign:"center"}} className="linkdecoration formobileonly" target="_blank" href="/blog"><p onMouseEnter={rotatedg} onMouseLeave={stoprotatedg}  style={{cursor:"pointer"}} className="learnmorecta vohlm2 ">View more articles <img className="" style={RotateDg}   src="images/rightarrow.png"/></p></a>
    </div>

































<Subscribe/>









    </div>






    <Footer/>
    </div>


    )
    
    
}


export {HomePage as default}